/* Louis Jewels — base v0.1 */

/* ===== testo del bottone «Aggiungi al carrello»: scritta e prezzo in due span (su mobile il prezzo va sotto, senza trattino) ===== */
window.ljSetAdd = function (btn, label, price) {
  if (!btn) return;
  var plain = price === undefined || price === null;
  var full = plain ? String(label) : label + ' — ' + price;
  if (btn.textContent === full && !!btn.querySelector('.lj-add__p') === !plain) return;
  if (plain) { btn.textContent = full; return; }
  btn.textContent = '';
  var t = document.createElement('span'); t.className = 'lj-add__t';
  [['lj-add__l', label], ['lj-add__d', ' — '], ['lj-add__p', price]].forEach(function (p) {
    var s = document.createElement('span'); s.className = p[0]; s.textContent = p[1]; t.appendChild(s);
  });
  btn.appendChild(t);
};
(function () {
  'use strict';

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.lj-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || document.documentElement.classList.contains('no-reveal')) {
      Array.prototype.forEach.call(els, function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(els, function (e) { io.observe(e); });
  }

  function rotators(scope) {
    var list = (scope || document).querySelectorAll('[data-rotator]:not([data-ready])');
    Array.prototype.forEach.call(list, function (el) {
      el.setAttribute('data-ready', '');
      var items = el.querySelectorAll('.lj-announce__item');
      if (items.length < 2) return;
      var i = 0, ms = parseInt(el.getAttribute('data-interval'), 10) || 4000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, ms);
    });
  }

  function product(scope) {
    var sec = (scope || document).querySelector('[data-product-section]');
    if (!sec || sec.hasAttribute('data-ready')) return;
    sec.setAttribute('data-ready', '');
    var dataEl = sec.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = document.getElementById('product-form-' + sec.getAttribute('data-section-id'));
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[data-add]');

    function update() {
      var groups = sec.querySelectorAll('[data-option]');
      var sel = Array.prototype.map.call(groups, function (g) {
        var c = g.querySelector('input:checked');
        var out = g.querySelector('[data-option-value]');
        if (c && out) out.textContent = c.value;
        return c ? c.value : null;
      });
      var v = variants.filter(function (x) { return x.options.join('|') === sel.join('|'); })[0];
      if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
      idInput.value = v.id;
      var zero = !!v.zero;
      btn.setAttribute('data-zero', zero ? 'true' : 'false');
      btn.setAttribute('data-avail', v.available ? 'true' : 'false');
      btn.removeAttribute('data-blocked');
      btn.disabled = !v.available;
      if (v.available) window.ljSetAdd(btn, btn.getAttribute('data-label'), v.price); else window.ljSetAdd(btn, btn.getAttribute('data-soldout'));
      var pr = sec.querySelector('.lj-price'); if (pr) pr.classList.toggle('is-zero', zero);
      var p = sec.querySelector('[data-price-current]'); if (p) p.textContent = (zero && pr) ? pr.getAttribute('data-zero-text') : v.price;
      var c = sec.querySelector('[data-price-compare]'); if (c) { c.textContent = zero ? '' : v.compare; c.hidden = zero || !v.compare; }
      var b = sec.querySelector('[data-price-badge]'); if (b) { b.textContent = (!zero && v.save) ? 'Risparmia ' + v.save : ''; b.hidden = zero || !v.save; }
      if (window.ljZeroRefresh) window.ljZeroRefresh();
      if (!document.documentElement.classList.contains('lj-quick') && window.history && history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
    }
    sec.addEventListener('change', function (e) { if (e.target.closest('[data-option]')) update(); });
  }

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-thumb]'))) {
      var sec = t.closest('[data-product-section]');
      var i = parseInt(t.getAttribute('data-thumb'), 10);
      Array.prototype.forEach.call(sec.querySelectorAll('[data-slide]'), function (s, k) { s.classList.toggle('is-active', k === i); });
      Array.prototype.forEach.call(sec.querySelectorAll('[data-thumb]'), function (s, k) { s.classList.toggle('is-active', k === i); });
    }
    if ((t = e.target.closest('[data-qty]'))) {
      var input = t.parentNode.querySelector('input');
      var n = parseInt(input.value, 10) || 1;
      n += t.getAttribute('data-qty') === 'plus' ? 1 : -1;
      input.value = Math.max(1, n);
    }
    if ((t = e.target.closest('[data-readmore-btn]'))) {
      t.closest('[data-readmore]').classList.add('is-open');
    }
  });

  function init(scope) { reveal(scope); rotators(scope); product(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ===== v0.2 home ===== */
(function () {
  'use strict';
  var design = !!(window.Shopify && window.Shopify.designMode);

  function heroes(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-hero]:not([data-ready])'), function (el) {
      el.setAttribute('data-ready', '');
      var slides = el.querySelectorAll('.lj-hero__slide');
      var dots = el.querySelectorAll('[data-hero-dot]');
      if (slides.length < 2) return;
      var i = 0, timer, ms = parseInt(el.getAttribute('data-interval'), 10) || 6000;
      function go(n) {
        slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
      }
      function start() { if (!design) timer = setInterval(function () { go(i + 1); }, ms); }
      Array.prototype.forEach.call(dots, function (d, k) {
        d.addEventListener('click', function () { clearInterval(timer); go(k); start(); });
      });
      /* swipe con il dito (mobile): la direzione si sceglie dall'editor (data-swipe) */
      var swipe = el.getAttribute('data-swipe') || 'left-prev', sx = null, sy = null;
      el.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { sx = null; return; }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      el.addEventListener('touchcancel', function () { sx = null; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        sx = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        var toLeft = dx < 0;
        var next = swipe === 'left-next' ? toLeft : !toLeft;
        clearInterval(timer); go(i + (next ? 1 : -1)); start();
      }, { passive: true });
      el.__go = go;
      start();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-track-btn]');
    if (!b) return;
    var track = b.closest('.lj-fc').querySelector('.lj-track');
    var dir = b.getAttribute('data-track-btn') === 'next' ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest && e.target.closest('[data-hero]');
    if (!hero || !hero.__go) return;
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.lj-hero__slide'));
    hero.__go(slides.indexOf(e.target));
  });

  function init(scope) { heroes(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ===== v0.3 header: drawer + ricerca ===== */
(function () {
  'use strict';
  var timer, ctl;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function drawer(open) {
    var d = document.querySelector('[data-drawer]'); if (!d) return;
    d.classList.toggle('is-open', open);
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('lj-lock', open);
    Array.prototype.forEach.call(document.querySelectorAll('[data-drawer-open]'), function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  function search(open) {
    var p = document.querySelector('[data-search]'); if (!p) return;
    p.classList.toggle('is-open', open);
    Array.prototype.forEach.call(document.querySelectorAll('[data-search-toggle]'), function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) setTimeout(function () { var i = p.querySelector('input[type=search]'); if (i) i.focus(); }, 60);
  }
  function money(v) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: cur }).format(parseFloat(v)); }
    catch (e) { return v; }
  }
  /* parole cercate: le parole di 5+ lettere perdono l'ultima lettera («anelli» trova «anello») */
  function qwords(q) {
    return q.toLowerCase().split(/\s+/).filter(Boolean).map(function (w) { return w.length >= 5 ? w.slice(0, -1) : w; });
  }
  /* pertinente = la parola cercata è nel titolo o nei tag */
  function isRel(p, ws) {
    var h = (String(p.title || '') + ' ' + (p.tags || []).join(' ')).toLowerCase();
    return ws.every(function (w) { return h.indexOf(w) > -1; });
  }
  function suggest(q, box) {
    if (ctl) ctl.abort();
    ctl = window.AbortController ? new AbortController() : null;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var n = Math.max(1, Math.min(20, parseInt(box.getAttribute('data-n'), 10) || 12));
    var base = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
    function get(url) {
      return fetch(url, ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
        return (d.resources && d.resources.results && d.resources.results.products) || [];
      });
    }
    /* tre richieste (Shopify ne dà al massimo 10 ciascuna): solo titolo, solo tag, ricerca normale.
       Qualunque cosa risponda Shopify, in anteprima entra solo chi ha la parola cercata nel titolo o nei tag. */
    function safe(url) { return get(url).catch(function (err) { if (err && err.name === 'AbortError') throw err; return []; }); }
    var T = safe(base + '&resources[options][fields]=title');
    var G = safe(base + '&resources[options][fields]=tag');
    var B = get(base);
    Promise.all([T, G, B]).then(function (r) {
      var ws = qwords(q), seen = {}, rel = [];
      function key(p) { return String(p.id || p.url); }
      r.forEach(function (list) {
        list.forEach(function (p) { if (seen[key(p)]) return; seen[key(p)] = 1; if (isRel(p, ws)) rel.push(p); });
      });
      var items = rel.slice(0, n);
      var all = '<a class="lj-sr lj-sr--all" href="' + root + 'search?type=product&q=' + encodeURIComponent(q) + '">Vedi tutti i risultati →</a>';
      if (!items.length) { box.innerHTML = (r[2].length ? '<p class="lj-muted" style="grid-column:1/-1">Nessun risultato pertinente per «' + esc(q) + '».</p>' + all : '<p class="lj-muted" style="grid-column:1/-1">Nessun risultato per «' + esc(q) + '».</p>'); return; }
      box.innerHTML = items.map(function (p) {
        var img = p.image ? '<img loading="lazy" alt="" src="' + esc(p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=300') + '">' : '';
        return '<a class="lj-sr" href="' + esc(p.url) + '">' + img + '<span>' + esc(p.title) + '</span><em>' + esc(money(p.price)) + '</em></a>';
      }).join('') + all;
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) return drawer(true);
    if (e.target.closest('[data-drawer-close]')) return drawer(false);
    if (e.target.closest('[data-search-toggle]')) {
      var p = document.querySelector('[data-search]');
      return search(!(p && p.classList.contains('is-open')));
    }
    if (e.target.closest('[data-search-close]')) return search(false);
    if (!e.target.closest('.lj-header')) search(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { drawer(false); search(false); } });
  document.addEventListener('input', function (e) {
    var inp = e.target.closest && e.target.closest('[data-search] input[type=search]'); if (!inp) return;
    var box = document.querySelector('[data-search-results]');
    clearTimeout(timer);
    var q = inp.value.trim();
    if (q.length < 2) { box.innerHTML = ''; return; }
    timer = setTimeout(function () { suggest(q, box); }, 250);
  });
  window.addEventListener('resize', function () { if (window.innerWidth >= 760 && !document.querySelector('.lj-hx--burger')) drawer(false); });
})();


/* ===== barra categorie: frecce di scorrimento ===== */
(function () {
  'use strict';
  function setup(nav) {
    if (nav.__cb) return; nav.__cb = true;
    var list = nav.querySelector('[data-catbar-list]');
    var prev = nav.querySelector('[data-catbar-prev]');
    var next = nav.querySelector('[data-catbar-next]');
    if (!list || !prev || !next) return;
    function update() {
      var max = list.scrollWidth - list.clientWidth;
      prev.hidden = list.scrollLeft <= 2;
      next.hidden = list.scrollLeft >= max - 2;
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth * 0.7, behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth * 0.7, behavior: 'smooth' }); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }
  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.lj-catbar'), setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ===== v0.4 carosello: frecce attive/disattive ===== */
(function () {
  'use strict';
  function setup(fc) {
    if (fc.__tr) return;
    var track = fc.querySelector('.lj-track');
    if (!track) return;
    fc.__tr = true;
    var prev = fc.querySelector('[data-track-btn="prev"]');
    var next = fc.querySelector('[data-track-btn="next"]');
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }
  function init(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('.lj-fc'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ===== v0.6 ordine casuale e prodotti non ripetuti ===== */
(function () {
  'use strict';
  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  function cardsOf(box) {
    return Array.prototype.filter.call(box.children, function (c) { return c.hasAttribute && c.hasAttribute('data-pid'); });
  }
  function arrange(box) {
    var cards = cardsOf(box);
    if (box.hasAttribute('data-shuffle') && !box.__shuffled) {
      box.__shuffled = true;
      var tiers = {};
      cards.forEach(function (c) {
        var k = c.getAttribute('data-tier') || '0';
        (tiers[k] = tiers[k] || []).push(c);
      });
      var ordered = [];
      Object.keys(tiers).sort(function (a, b) { return b - a; }).forEach(function (k) {
        ordered = ordered.concat(shuffle(tiers[k]));
      });
      var tail = box.querySelector('.lj-more');
      ordered.forEach(function (c) { box.insertBefore(c, tail || null); });
      cards = ordered;
    }
    return cards;
  }
  function run() {
    var used = {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-fc-track]'), function (box) {
      var cards = arrange(box);
      var pooled = box.hasAttribute('data-random');
      var unique = box.hasAttribute('data-unique');
      var isM = window.matchMedia && window.matchMedia('(max-width:759px)').matches;
      var show = parseInt(box.getAttribute(isM ? 'data-show-m' : 'data-show-d') || box.getAttribute('data-show'), 10) || cards.length;
      var n = 0;
      cards.forEach(function (c) {
        var id = c.getAttribute('data-pid');
        if (!pooled) { if (!c.hidden) used[id] = 1; return; }
        if (unique && used[id]) { c.hidden = true; return; }
        if (n < show) { c.hidden = false; used[id] = 1; n++; } else { c.hidden = true; }
      });
      box.classList.add('is-ready');
    });
    document.dispatchEvent(new CustomEvent('lj:arranged'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  if (window.matchMedia) {
    var mqRun = window.matchMedia('(max-width:759px)');
    if (mqRun.addEventListener) mqRun.addEventListener('change', run); else if (mqRun.addListener) mqRun.addListener(run);
  }
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
    document.addEventListener(ev, run);
  });
})();

/* ===== v0.8 griglia a pagine: righe × colonne, frecce per gli altri prodotti ===== */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(max-width:759px)') : { matches: false };

  function setup(fc) {
    var grid = fc.querySelector('[data-fc-grid]');
    if (!grid) return;
    if (!fc.__pg) {
      fc.__pg = { page: 0 };
      var prev = fc.querySelector('[data-grid-btn="prev"]');
      var next = fc.querySelector('[data-grid-btn="next"]');
      fc.__pg.prev = prev; fc.__pg.next = next;
      function turn(d) {
        grid.classList.add('is-turn');
        setTimeout(function () { fc.__pg.page = Math.max(0, fc.__pg.page + d); apply(fc, grid); grid.classList.remove('is-turn'); }, 180);
      }
      if (prev) prev.addEventListener('click', function () { turn(-1); });
      if (next) next.addEventListener('click', function () { turn(1); });
    }
    fc.__pg.page = 0;
    apply(fc, grid);
  }
  function read(grid, key) {
    return parseInt(grid.getAttribute('data-' + key + (mq.matches ? '-m' : '-d')), 10) || 1;
  }
  function apply(fc, grid) {
    var st = fc.__pg;
    var per = read(grid, 'cols') * read(grid, 'rows');
    var max = read(grid, 'max');
    var cards = Array.prototype.filter.call(grid.children, function (c) { return c.hasAttribute('data-pid') && !c.hidden; });
    var total = Math.min(cards.length, max);
    var pages = Math.max(1, Math.ceil(total / per));
    if (st.page > pages - 1) st.page = pages - 1;
    cards.forEach(function (c, i) {
      var on = i < total && i >= st.page * per && i < (st.page + 1) * per;
      c.classList.toggle('lj-pg-off', !on);
    });
    grid.classList.add('is-paged');
    [st.prev, st.next].forEach(function (b) { if (b) b.hidden = pages < 2; });
    if (st.prev) st.prev.disabled = st.page <= 0;
    if (st.next) st.next.disabled = st.page >= pages - 1;
    if (/[?&]ljdebug/.test(location.search)) debugInfo(fc, grid, { per: per, max: max, total: total, pages: pages, cards: cards.length });
  }
  function debugInfo(fc, grid, i) {
    var box = document.getElementById('lj-dbg-grid');
    if (!box) {
      box = document.createElement('pre');
      box.id = 'lj-dbg-grid';
      box.style.cssText = 'position:fixed;left:0;bottom:0;z-index:2147483647;max-width:100%;max-height:45%;overflow:auto;margin:0;padding:8px;background:#000;color:#7CFC00;font:11px/1.35 monospace;white-space:pre-wrap';
      document.body.appendChild(box);
      box.__rows = {};
    }
    var t = fc.querySelector('.lj-title');
    var name = (t && t.textContent.trim()) || 'griglia';
    box.__rows[name] =
      name + ': finestra ' + window.innerWidth + 'px (' + (mq.matches ? 'MOBILE' : 'DESKTOP') + ')' +
      ' | colonne ' + grid.getAttribute('data-cols-' + (mq.matches ? 'm' : 'd')) +
      ' × righe ' + grid.getAttribute('data-rows-' + (mq.matches ? 'm' : 'd')) + ' = ' + i.per + ' per pagina' +
      ' | massimo ' + i.max +
      ' | card ricevute dal server ' + grid.querySelectorAll('[data-pid]').length +
      ' (nascoste dal server ' + grid.querySelectorAll('[data-pid][hidden]').length + ')' +
      ' | usate ' + i.total + ' | pagine ' + i.pages +
      ' | frecce ' + (fc.querySelector('[data-grid-btn]') ? (i.pages > 1 ? 'visibili' : 'nascoste (una sola pagina)') : 'NON PRESENTI nella sezione');
    box.textContent = Object.keys(box.__rows).map(function (k) { return box.__rows[k]; }).join('\n');
  }
  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.lj-fc'), setup);
  }
  function all() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('lj:arranged', all);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (mq.addEventListener) mq.addEventListener('change', all); else if (mq.addListener) mq.addListener(all);
})();

/* ===== v0.7 seconda foto al passaggio del mouse ===== */
(function () {
  'use strict';
  document.addEventListener('mouseover', function (e) {
    var m = e.target.closest && e.target.closest('[data-hover-src]');
    if (!m || m.__alt) return;
    m.__alt = true;
    var im = new Image();
    im.className = 'lj-card__alt';
    im.alt = '';
    im.decoding = 'async';
    im.onload = function () { im.classList.add('is-on'); };
    im.src = m.getAttribute('data-hover-src');
    m.appendChild(im);
  });
})();

/* ===== v0.4 pannello prodotto: la pagina vera dentro un riquadro ===== */
(function () {
  'use strict';
  var inFrame = document.documentElement.classList.contains('lj-quick');
  /* dentro il riquadro non serve altro: ci pensa lo script iniziale che il pannello vi inserisce */
  if (inFrame) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SELF = (document.currentScript && document.currentScript.src) || (function () {
    var s = document.querySelector('script[src*="louis-base.js"],script[data-src*="louis-base.js"]');
    return s ? (s.getAttribute('src') || s.getAttribute('data-src') || '') : '';
  })();

  /* Questo codice viene copiato così com'è dentro il riquadro: deve restare autonomo (niente variabili esterne). */
  function frameMain(cfg) {
    var w = window, d = document;
    var seen = false, notified = false, wd = null;
    var dbgLines = [], dbgBox = null;
    function log(m) {
      if (!cfg.debug) return;
      dbgLines.push(m);
      if (!d.body) return;
      if (!dbgBox) {
        dbgBox = d.createElement('pre');
        dbgBox.style.cssText = 'position:fixed;left:0;top:0;z-index:2147483647;max-width:100%;max-height:60%;overflow:auto;margin:0;padding:8px;background:#000;color:#7CFC00;font:11px/1.35 monospace;white-space:pre-wrap;word-break:break-all';
        d.body.appendChild(dbgBox);
      }
      dbgBox.textContent = dbgLines.slice(-40).join('\n');
    }
    log('riquadro avviato | designMode=' + !!(w.Shopify && w.Shopify.designMode));
    w.addEventListener('error', function (e) { log('ERRORE: ' + e.message + ' @' + String(e.filename || '').split('/').pop() + ':' + e.lineno); });
    w.addEventListener('unhandledrejection', function (e) { log('PROMESSA RIFIUTATA: ' + (e.reason && e.reason.message || e.reason)); });
    d.addEventListener('DOMContentLoaded', function () {
      var hosts = {};
      Array.prototype.forEach.call(d.scripts, function (s) { var u = s.src || s.getAttribute('data-src') || ''; var m = u.match(/\/\/([^\/]+)/); if (m) hosts[m[1]] = (hosts[m[1]] || 0) + 1; });
      log('DOM pronto | script del tema: ' + !!d.querySelector('script[src*="louis-base"]') + ' | form: ' + d.querySelectorAll('form[action*="/cart/add"]').length + ' | bottoni: ' + d.querySelectorAll('[data-add]').length);
      log('script da: ' + Object.keys(hosts).slice(0, 14).join(', '));
    });
    w.addEventListener('load', function () { log('pagina caricata del tutto'); });
    function getRoot() { return (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/'; }
    function notify() {
      if (notified) return;
      notified = true;
      setTimeout(function () { notified = false; }, 1500);
      try { w.parent.postMessage({ ljAdded: true }, '*'); } catch (x) {}
    }
    function status(msg, isErr, linkText) {
      if (!d.body) return;
      var s = d.getElementById('lj-qs');
      if (!s) { s = d.createElement('div'); s.id = 'lj-qs'; s.className = 'lj-quick-status'; d.body.appendChild(s); }
      s.textContent = msg || '';
      if (linkText) {
        var a = d.createElement('a');
        a.href = cfg.url; a.textContent = ' ' + linkText; a.style.cssText = 'color:#fff;text-decoration:underline';
        s.appendChild(a);
      }
      s.className = 'lj-quick-status' + (isErr ? ' is-err' : '');
      s.hidden = !msg;
    }
    /* alcune app riscrivono gli indirizzi sul dominio interno del negozio (xxx.myshopify.com): lo riporto sul dominio vero */
    function fixUrl(u) {
      try {
        var base = w.parent.location;
        var a = new URL(u, base.href);
        var shop = (w.Shopify && w.Shopify.shop) || '';
        var foreign = a.hostname !== base.hostname && (shop ? a.hostname === shop : /\.myshopify\.com$/i.test(a.hostname));
        if (foreign) { var fixed = base.origin + a.pathname + a.search + a.hash; log('indirizzo corretto: ' + a.hostname + ' -> ' + base.hostname); return fixed; }
      } catch (e) {}
      return u;
    }
    /* vede ogni aggiunta al carrello, di chiunque (tema, Easify, upsell...) */
    var re = /\/cart\/add(\.js)?([?#]|$)/;
    var of = w.fetch;
    if (of) {
      w.fetch = function (i) {
        var args = Array.prototype.slice.call(arguments);
        var u = '';
        try {
          if (typeof i === 'string') { args[0] = fixUrl(i); u = args[0]; }
          else if (i && i.url) { var nu = fixUrl(i.url); if (nu !== i.url) args[0] = new Request(nu, i); u = nu; }
        } catch (e) {}
        var p = of.apply(this, args);
        if (re.test(u)) { seen = true; log('richiesta aggiunta -> ' + u); p.then(function (r) { log('risposta aggiunta: ' + (r && r.status)); if (r && r.ok) notify(); }).catch(function (x) { log('aggiunta fallita: ' + x); }); }
        return p;
      };
    }
    var oo = w.XMLHttpRequest.prototype.open, os = w.XMLHttpRequest.prototype.send;
    w.XMLHttpRequest.prototype.open = function (m, u) {
      var args = Array.prototype.slice.call(arguments);
      try { args[1] = fixUrl(String(u)); } catch (e) {}
      this.__lj = re.test(String(args[1]));
      return oo.apply(this, args);
    };
    w.XMLHttpRequest.prototype.send = function () {
      if (this.__lj) { seen = true; log('richiesta aggiunta (XHR)'); this.addEventListener('load', function () { log('risposta XHR: ' + this.status); if (this.status >= 200 && this.status < 300) notify(); }); }
      return os.apply(this, arguments);
    };

    /* galleria: miniature verticali + frecce su/giù, frecce destra/sinistra sull'immagine grande */
    function chevron(p) { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="' + p + '"/></svg>'; }
    function sized(u, wd2) {
      if (!u) return u;
      if (u.indexOf('//') === 0) u = 'https:' + u;
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + wd2;
    }
    function buildGallery(images, alt) {
      var el = d.createElement('div');
      el.className = 'lj-qg' + (images.length < 2 ? ' lj-qg--single' : '');
      var thumbs = images.map(function (src, i) {
        return '<button type="button" class="lj-qg__thumb' + (i === 0 ? ' is-active' : '') + '" data-qg-i="' + i + '" aria-label="Foto ' + (i + 1) + '"><img loading="lazy" alt="" src="' + sized(src, 160) + '"></button>';
      }).join('');
      el.innerHTML =
        (images.length > 1
          ? '<div class="lj-qg__thumbs">' +
            '<button type="button" class="lj-qg__tarrow lj-qg__tarrow--up" data-qg-up aria-label="Foto precedenti">' + chevron('M5 15l7-7 7 7') + '</button>' +
            '<div class="lj-qg__tlist" data-qg-list>' + thumbs + '</div>' +
            '<button type="button" class="lj-qg__tarrow lj-qg__tarrow--down" data-qg-down aria-label="Altre foto">' + chevron('M5 9l7 7 7-7') + '</button>' +
            '</div>'
          : '') +
        '<div class="lj-qg__main"><img data-qg-main alt="' + String(alt || '').replace(/"/g, '&quot;') + '" src="' + sized(images[0], 1000) + '">' +
        (images.length > 1
          ? '<div class="lj-qg__arrows"><button type="button" data-qg-prev aria-label="Foto precedente">←</button><button type="button" data-qg-next aria-label="Foto successiva">→</button></div>'
          : '') +
        '</div>';
      if (images.length < 2) return el;
      var idx = 0;
      var main = el.querySelector('[data-qg-main]');
      var list = el.querySelector('[data-qg-list]');
      var items = Array.prototype.slice.call(el.querySelectorAll('.lj-qg__thumb'));
      var up = el.querySelector('[data-qg-up]');
      var down = el.querySelector('[data-qg-down]');
      function updArrows() {
        up.disabled = list.scrollTop <= 2;
        down.disabled = list.scrollTop >= list.scrollHeight - list.clientHeight - 2;
      }
      function go(n) {
        idx = (n + images.length) % images.length;
        main.src = sized(images[idx], 1000);
        items.forEach(function (b, k) { b.classList.toggle('is-active', k === idx); });
        var t = items[idx], top = t.offsetTop, h = t.offsetHeight;
        if (top < list.scrollTop) list.scrollTo({ top: Math.max(0, top - 4), behavior: 'smooth' });
        else if (top + h > list.scrollTop + list.clientHeight) list.scrollTo({ top: top + h - list.clientHeight + 4, behavior: 'smooth' });
      }
      el.addEventListener('click', function (e) {
        var b;
        if ((b = e.target.closest('[data-qg-i]'))) return go(parseInt(b.getAttribute('data-qg-i'), 10));
        if (e.target.closest('[data-qg-prev]')) return go(idx - 1);
        if (e.target.closest('[data-qg-next]')) return go(idx + 1);
        if (e.target.closest('[data-qg-up]')) return list.scrollBy({ top: -list.clientHeight * 0.8, behavior: 'smooth' });
        if (e.target.closest('[data-qg-down]')) return list.scrollBy({ top: list.clientHeight * 0.8, behavior: 'smooth' });
      });
      list.addEventListener('scroll', updArrows, { passive: true });
      var sx = null;
      var box = el.querySelector('.lj-qg__main');
      box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      });
      setTimeout(updArrows, 80);
      return el;
    }
    function initGallery() {
      var slot = d.querySelector('[data-qg-images]');
      if (!slot) return;
      try {
        var imgs = JSON.parse(slot.getAttribute('data-qg-images'));
        slot.parentNode.replaceChild(buildGallery(imgs, slot.getAttribute('data-qg-alt')), slot);
      } catch (e) {}
    }
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', initGallery); else initGallery();

    /* i link aprono la pagina principale, non il riquadro */
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented) return;
      var h = a.getAttribute('href') || '';
      if (!h || h.charAt(0) === '#' || /^javascript:/i.test(h) || a.target === '_blank') return;
      e.preventDefault();
      try { w.top.location.href = a.href; } catch (x) {}
    });

    /* se dopo il click sul bottone non parte nessuna aggiunta, lo dico invece di restare in silenzio */
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('form[action*="/cart/add"] [type="submit"],[data-add]');
      if (!b) return;
      seen = false;
      log('click su ' + b.tagName + ' | disabilitato=' + !!b.disabled + ' | testo=' + (b.textContent || '').trim().slice(0, 30));
      clearTimeout(wd);
      wd = setTimeout(function () {
        log('dopo 2,8 s: aggiunta partita=' + seen);
        if (!seen) status('Non sono riuscito ad aggiungerlo da qui.', true, 'Apri la pagina del prodotto');
      }, 2800);
    }, true);

    /* aggiunta al carrello fatta dal tema (se non l'ha già gestita un'app) */
    d.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.matches && form.matches('form[action*="/cart/add"]')) log('evento submit | già gestito da altri=' + e.defaultPrevented);
      if (e.defaultPrevented) return;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      seen = true;
      var btn = form.querySelector('[type="submit"]');
      var old = form.parentNode.querySelector('.lj-quick-err'); if (old) old.remove();
      if (btn) btn.disabled = true;
      status('Aggiungo al carrello…');
      var addUrl = getRoot() + 'cart/add.js';
      try { addUrl = new URL(addUrl, w.parent.location.href).href; } catch (x) {}
      log('aggiunta del tema -> ' + addUrl);
      (of || w.fetch).call(w, addUrl, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, d: j }; }); })
        .then(function (res) {
          if (res.ok) { status(''); notify(); if (btn) btn.disabled = false; return; }
          var msg = res.d.description || res.d.message || 'Non è stato possibile aggiungere il prodotto. Riprova.';
          var p = d.createElement('p');
          p.className = 'lj-quick-err';
          p.textContent = msg;
          form.parentNode.insertBefore(p, form);
          status(msg, true);
          if (btn) btn.disabled = false;
        })
        .catch(function () { status('Connessione non riuscita. Riprova.', true); if (btn) btn.disabled = false; });
    });
  }

  /* ---------- NELLA PAGINA PRINCIPALE ---------- */
  var sheet, frame, toast, toastTimer, current = '', pending = false, startCount = 0, cacheHtml = {}, cacheJson = {};

  function el() {
    if (!sheet) {
      sheet = document.querySelector('[data-sheet]');
      if (sheet) {
        frame = sheet.querySelector('[data-sheet-frame]');
        toast = document.querySelector('[data-toast]');
        frame.addEventListener('load', function () {
          if (pending) { pending = false; sheet.classList.add('is-ready'); return; }
          /* il riquadro ha cambiato pagina da solo (es. un'app ha inviato il modulo): controllo se il carrello è cresciuto */
          if (!sheet.classList.contains('is-open') || !current) return;
          var u = current;
          fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
            if (c.item_count > startCount) added(); else if (current === u) show(u);
          }).catch(function () {});
        });
      }
    }
    return !!(sheet && frame);
  }
  function cleanUrl(url) { return url.split('#')[0]; }
  function fetchHtml(url) {
    var u = cleanUrl(url);
    if (!cacheHtml[u]) {
      cacheHtml[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.text();
      });
      cacheHtml[u].catch(function () { delete cacheHtml[u]; });
    }
    return cacheHtml[u];
  }
  function fetchJson(url) {
    var u = cleanUrl(url).split('?')[0] + '.js';
    if (!cacheJson[u]) {
      cacheJson[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return cacheJson[u];
  }
  function setDoc(html) { pending = true; frame.srcdoc = html; }

  function show(url) {
    current = url;
    sheet.classList.remove('is-ready');
    Promise.all([fetchHtml(url), fetchJson(url)]).then(function (res) {
      if (current !== url) return;
      var doc = new DOMParser().parseFromString(res[0], 'text/html');
      var sec = doc.querySelector('[data-product-section]');
      if (!sec) throw new Error('no section');
      var keep = sec.closest('.shopify-section');
      Array.prototype.forEach.call(doc.querySelectorAll('.shopify-section'), function (s) { if (s !== keep) s.remove(); });
      Array.prototype.forEach.call(doc.querySelectorAll('[data-sheet],[data-toast]'), function (n) { n.remove(); });
      doc.documentElement.classList.add('lj-quick');

      /* il nostro script lo carichiamo noi, così non dipende da ottimizzatori di velocità o da script ritardati */
      if (SELF) {
        Array.prototype.forEach.call(doc.querySelectorAll('script'), function (s) {
          if (/louis-base\.js/.test((s.getAttribute('src') || '') + (s.getAttribute('data-src') || ''))) s.remove();
        });
        var own = doc.createElement('script');
        own.src = SELF;
        doc.body.appendChild(own);
      }

      var images = (res[1] && res[1].images && res[1].images.length) ? res[1].images.slice() : [];
      var gal = doc.querySelector('.lj-gallery');
      if (!images.length && gal) {
        Array.prototype.forEach.call(gal.querySelectorAll('.lj-slide img'), function (im) { if (im.getAttribute('src')) images.push(im.getAttribute('src')); });
      }
      if (images.length) {
        var slot = doc.createElement('div');
        slot.className = 'lj-gallery-slot';
        slot.setAttribute('data-qg-images', JSON.stringify(images));
        slot.setAttribute('data-qg-alt', (res[1] && res[1].title) || '');
        if (gal) gal.parentNode.replaceChild(slot, gal); else sec.insertBefore(slot, sec.firstChild);
      }

      /* script iniziale: parte per primo, prima di qualsiasi app */
      var main = doc.createElement('script');
      main.textContent = '(' + frameMain.toString() + ')(' + JSON.stringify({ url: cleanUrl(url), debug: /[?&]ljdebug/.test(location.search) }).replace(/</g, '\\u003c') + ');';
      doc.head.insertBefore(main, doc.head.firstChild);

      setDoc('<!doctype html>' + doc.documentElement.outerHTML);
    }).catch(function () {
      if (current !== url) return;
      setDoc('<!doctype html><html><body style="font-family:sans-serif;text-align:center;padding:40px 20px"><p>Non riesco a caricare il prodotto.</p><a target="_top" href="' + cleanUrl(url) + '">Apri la pagina del prodotto</a></body></html>');
    });
  }
  function open(url) {
    if (!el()) return;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lj-lock');
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { startCount = c.item_count; }).catch(function () {});
    show(url);
  }
  function close() {
    if (!el()) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lj-lock');
  }
  function refreshCart() {
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (n) { n.textContent = c.item_count; });
    }).catch(function () {});
  }
  function added() {
    close();
    current = '';
    pending = false;
    refreshCart();
    if (toast) {
      toast.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 5000);
    }
  }

  var hoverTimer;
  function preload(btn) {
    if (!btn || !el() || sheet.classList.contains('is-open')) return;
    var u = btn.getAttribute('data-quick-add');
    fetchHtml(u).catch(function () {});
    fetchJson(u);
  }
  document.addEventListener('mouseover', function (e) {
    var b = e.target.closest && e.target.closest('[data-quick-add]');
    if (!b) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { preload(b); }, 150);
  });
  document.addEventListener('mouseout', function (e) {
    if (e.target.closest && e.target.closest('[data-quick-add]')) clearTimeout(hoverTimer);
  });
  document.addEventListener('touchstart', function (e) {
    preload(e.target.closest && e.target.closest('[data-quick-add]'));
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (b) { e.preventDefault(); open(b.getAttribute('data-quick-add')); return; }
    if (e.target.closest('[data-sheet-close]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  window.addEventListener('message', function (e) {
    if (!el() || e.source !== frame.contentWindow) return;
    if (e.data && e.data.ljAdded) added();
  });
})();

/* ===== v0.9 menu a tendina dei bottoni Orecchio / Viso / Corpo ===== */
(function () {
  'use strict';
  var canHover = window.matchMedia && window.matchMedia('(hover:hover)').matches;
  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-zone-dd].is-open'), function (d) {
      if (d === except) return;
      d.classList.remove('is-open');
      var b = d.querySelector('[data-zone-btn]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-zone-btn]');
    if (!btn) { if (!(e.target.closest && e.target.closest('[data-zone-dd]'))) closeAll(); return; }
    var dd = btn.closest('[data-zone-dd]');
    if (!dd || !dd.querySelector('.lj-zone__menu-wrap')) return;       /* niente menu: il bottone si comporta da link o da etichetta */
    if (canHover) return;                                              /* con il mouse il menu si apre al passaggio */
    var open = dd.classList.contains('is-open');
    var hasLink = btn.tagName === 'A' && btn.getAttribute('href');
    if (!open) {
      e.preventDefault();
      closeAll(dd);
      dd.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    } else if (!hasLink) {
      e.preventDefault();
      dd.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();

/* ===== v0.10 get the look: il testo fa zoom avanti e indietro finché c'è il mouse, poi finisce il ciclo ===== */
(function () {
  'use strict';
  document.addEventListener('mouseover', function (e) {
    var c = e.target.closest && e.target.closest('[data-gtl-cta]');
    if (!c) return;
    c.__over = true;
    c.classList.add('is-pulsing');
  });
  document.addEventListener('mouseout', function (e) {
    var c = e.target.closest && e.target.closest('[data-gtl-cta]');
    if (!c || (e.relatedTarget && c.contains(e.relatedTarget))) return;
    c.__over = false;
  });
  document.addEventListener('animationiteration', function (e) {
    var c = e.target.closest && e.target.closest('[data-gtl-cta]');
    if (c && !c.__over) c.classList.remove('is-pulsing');
  });
})();

/* ===== v0.11 swipe sulla griglia a pagine: scorri a sinistra o a destra per cambiare pagina ===== */
(function () {
  'use strict';
  var sx = null, sy = null;
  document.addEventListener('touchstart', function (e) {
    var g = e.target.closest && e.target.closest('[data-fc-grid]');
    if (!g) { sx = null; return; }
    sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (sx === null) return;
    var g = e.target.closest && e.target.closest('[data-fc-grid]');
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    sx = null;
    if (!g || Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var fc = g.closest('.lj-fc');
    var b = fc && fc.querySelector('[data-grid-btn="' + (dx < 0 ? 'next' : 'prev') + '"]');
    if (b && !b.hidden && !b.disabled) b.click();
  }, { passive: true });
})();


/* ===== v0.12 recensioni ===== */
(function () {
  var mq = window.matchMedia('(max-width: 759px)');
  function init(root) {
    if (root.__rv) return; root.__rv = true;
    var track = root.querySelector('[data-rv-track]'); if (!track) return;
    var nav = root.querySelector('[data-rv-nav]');
    var prev = root.querySelector('[data-rv-btn="prev"]'), next = root.querySelector('[data-rv-btn="next"]');
    var design = !!(window.Shopify && window.Shopify.designMode);
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-rv-card]'));
    if (root.hasAttribute('data-rv-random') && !design) {
      for (var i = cards.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = cards[i]; cards[i] = cards[j]; cards[j] = t; }
      cards.forEach(function (c) { track.appendChild(c); });
    }
    function limit() { return parseInt(root.getAttribute(mq.matches ? 'data-rv-m' : 'data-rv-d'), 10) || cards.length; }
    function perView() { return mq.matches ? 1 : (parseInt(root.getAttribute('data-rv-cols'), 10) || 1); }
    function arrange() {
      var n = limit();
      cards.forEach(function (c, k) { c.hidden = k >= n; });
      track.scrollLeft = 0;
      sizeThumbs();
      if (nav) nav.classList.toggle('is-single', Math.min(n, cards.length) <= perView());
      state();
    }
    function sizeThumbs() {
      var max = 0;
      cards.forEach(function (c) {
        if (c.hidden) return;
        var b = c.querySelector('.lj-rv__body'); if (!b) return;
        c.style.removeProperty('--rv-thx');
        var h = Math.round(b.getBoundingClientRect().height * 10) / 10;
        if (h > max) max = h;
      });
      /* stessa altezza per tutte le miniature (e quindi per tutte le schede) */
      if (max > 0) cards.forEach(function (c) { if (!c.hidden) c.style.setProperty('--rv-thx', max + 'px'); });
    }
    function step() { var vis = cards.filter(function (c) { return !c.hidden; }), pv = perView(); return vis.length > pv ? vis[pv].offsetLeft - vis[0].offsetLeft : track.clientWidth; }   /* una pagina alla volta: 1 scheda su mobile, «visibili per volta» su desktop */
    function state() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max;
    }
    function go(dir) { track.scrollBy({ left: dir * step(), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(state); }, { passive: true });
    var f = function () { arrange(); };
    if (mq.addEventListener) mq.addEventListener('change', f); else mq.addListener(f);
    arrange();
    track.classList.add('is-ready');
    sizeThumbs();
    window.addEventListener('load', sizeThumbs);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeThumbs);
    window.addEventListener('resize', function () { clearTimeout(root.__rt); root.__rt = setTimeout(sizeThumbs, 150); });
    root.addEventListener('shopify:block:select', function (e) {
      var c = e.target; if (c && c.hidden) c.hidden = false;
      if (c) track.scrollTo({ left: c.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
  }
  function all(r) { (r || document).querySelectorAll('[data-rv]').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();


/* ===== v0.13 galleria prodotto ===== */
(function () {
  function init(root) {
    if (root.__pg) return; root.__pg = true;
    var track = root.querySelector('[data-pg-track]'); if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var n = slides.length; if (n < 2) return;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pg-thumb]'));
    var strip = root.querySelector('[data-pg-strip]');
    var tp = root.querySelector('[data-pg-tprev]'), tn = root.querySelector('[data-pg-tnext]');
    var prevs = root.querySelectorAll('[data-pg-btn="prev"]'), nexts = root.querySelectorAll('[data-pg-btn="next"]');
    var cur = 0;
    function idx() { var w = track.clientWidth || 1; return Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w))); }
    function go(i) { i = Math.max(0, Math.min(n - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function stripState() {
      if (!strip || !tp || !tn) return;
      var over = strip.scrollWidth > strip.clientWidth + 1;
      tp.hidden = !over; tn.hidden = !over;
      tp.disabled = strip.scrollLeft <= 1; tn.disabled = strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - 1;
    }
    function update() {
      cur = idx();
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
      Array.prototype.forEach.call(prevs, function (b) { b.disabled = cur === 0; });
      Array.prototype.forEach.call(nexts, function (b) { b.disabled = cur === n - 1; });
      var t = thumbs[cur];
      if (t && strip) {
        var l = t.offsetLeft, r = l + t.offsetWidth;
        if (l < strip.scrollLeft) strip.scrollTo({ left: l, behavior: 'smooth' });
        else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: r - strip.clientWidth, behavior: 'smooth' });
      }
      stripState();
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    Array.prototype.forEach.call(prevs, function (b) { b.addEventListener('click', function () { go(cur - 1); }); });
    Array.prototype.forEach.call(nexts, function (b) { b.addEventListener('click', function () { go(cur + 1); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    if (tp) tp.addEventListener('click', function () { strip.scrollBy({ left: -strip.clientWidth * 0.8, behavior: 'smooth' }); });
    if (tn) tn.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: 'smooth' }); });
    if (strip) strip.addEventListener('scroll', function () { requestAnimationFrame(stripState); }, { passive: true });
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt); rt = setTimeout(function () { track.scrollLeft = cur * track.clientWidth; update(); }, 120);
    });
    update();
  }
  function all(r) { (r || document).querySelectorAll('[data-pg]').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();


/* ===== v0.14 zoom galleria prodotto: popup con X (desktop e mobile; su mobile pizzico, trascinamento e doppio tocco) ===== */
(function () {
  var zm, st = {};
  var X = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14"/></svg>';
  function build() {
    zm = document.createElement('div');
    zm.className = 'lj-zm'; zm.hidden = true; zm.setAttribute('role', 'dialog'); zm.setAttribute('aria-modal', 'true'); zm.setAttribute('aria-label', 'Foto del prodotto');
    zm.innerHTML = '<div class="lj-zm__panel"><button type="button" class="lj-zm__close" aria-label="Chiudi">' + X + '</button>' +
      '<div class="lj-zm__stage"><img class="lj-zm__img" alt=""><div class="lj-zm__nav">' +
      '<button type="button" class="lj-arrow" data-zm="prev" aria-label="Foto precedente">&larr;</button>' +
      '<button type="button" class="lj-arrow" data-zm="next" aria-label="Foto successiva">&rarr;</button></div></div>' +
      '<div class="lj-zm__thumbs"><button type="button" class="lj-arrow lj-zm__tarrow" data-zm="tprev" aria-label="Anteprime precedenti" hidden>&larr;</button>' +
      '<div class="lj-zm__strip"></div>' +
      '<button type="button" class="lj-arrow lj-zm__tarrow" data-zm="tnext" aria-label="Anteprime successive" hidden>&rarr;</button></div></div>';
    document.body.appendChild(zm);
    st.img = zm.querySelector('.lj-zm__img'); st.strip = zm.querySelector('.lj-zm__strip');
    st.tp = zm.querySelector('[data-zm="tprev"]'); st.tn = zm.querySelector('[data-zm="tnext"]');
    st.prev = zm.querySelector('[data-zm="prev"]'); st.next = zm.querySelector('[data-zm="next"]');
    zm.addEventListener('click', function (e) { if (e.target === zm) close(); });
    zm.querySelector('.lj-zm__close').addEventListener('click', close);
    st.prev.addEventListener('click', function () { show(st.i - 1); });
    st.next.addEventListener('click', function () { show(st.i + 1); });
    st.tp.addEventListener('click', function () { st.strip.scrollBy({ left: -st.strip.clientWidth * 0.8, behavior: 'smooth' }); });
    st.tn.addEventListener('click', function () { st.strip.scrollBy({ left: st.strip.clientWidth * 0.8, behavior: 'smooth' }); });
    st.strip.addEventListener('scroll', stripState, { passive: true });
    st.img.addEventListener('load', function () { st.img.classList.remove('is-loading'); size(); });
    gestures(zm.querySelector('.lj-zm__stage'));
    document.addEventListener('keydown', function (e) {
      if (zm.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(st.i - 1);
      else if (e.key === 'ArrowRight') show(st.i + 1);
    });
    window.addEventListener('resize', function () { if (!zm.hidden) size(); });
  }
  /* zoom con le dita dentro il popup: pizzico = ingrandisce, un dito = sposta, doppio tocco = 2,5× / indietro */
  var G = { s: 1, x: 0, y: 0 };
  function gApply(anim) {
    var w = st.img.clientWidth || 1, h = st.img.clientHeight || 1;
    var mx = Math.max(0, (G.s - 1) * w / 2), my = Math.max(0, (G.s - 1) * h / 2);
    G.x = Math.max(-mx, Math.min(mx, G.x)); G.y = Math.max(-my, Math.min(my, G.y));
    st.img.classList.toggle('is-anim', !!anim);
    st.img.style.transform = G.s === 1 && !G.x && !G.y ? '' : 'translate(' + G.x + 'px,' + G.y + 'px) scale(' + G.s + ')';
    zm.classList.toggle('is-zoomed', G.s > 1.01);
  }
  function gReset() { G.s = 1; G.x = 0; G.y = 0; if (st.img) { st.img.classList.remove('is-anim'); st.img.style.transform = ''; } if (zm) zm.classList.remove('is-zoomed'); }
  function gestures(stage) {
    var pts = {}, base = null, lastTap = 0, tapX = 0, tapY = 0, moved = false;
    function count() { return Object.keys(pts).length; }
    function two() { var k = Object.keys(pts); return [pts[k[0]], pts[k[1]]]; }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y) || 1; }
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || e.target.closest('.lj-zm__nav')) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { stage.setPointerCapture(e.pointerId); } catch (x) {}
      moved = false;
      if (count() === 2) { var p = two(); base = { d: dist(p[0], p[1]), s: G.s, mx: (p[0].x + p[1].x) / 2, my: (p[0].y + p[1].y) / 2, x: G.x, y: G.y }; }
      else if (count() === 1) base = { px: e.clientX, py: e.clientY, x: G.x, y: G.y };
    });
    stage.addEventListener('pointermove', function (e) {
      var p = pts[e.pointerId]; if (!p) return;
      p.x = e.clientX; p.y = e.clientY;
      if (count() >= 2 && base && base.d) {
        var q = two(), s = Math.max(1, Math.min(4, base.s * dist(q[0], q[1]) / base.d));
        G.s = s; G.x = base.x + ((q[0].x + q[1].x) / 2 - base.mx); G.y = base.y + ((q[0].y + q[1].y) / 2 - base.my);
        moved = true; gApply(false);
      } else if (count() === 1 && base && G.s > 1.01) {
        G.x = base.x + (e.clientX - base.px); G.y = base.y + (e.clientY - base.py);
        if (Math.abs(e.clientX - base.px) + Math.abs(e.clientY - base.py) > 6) moved = true;
        gApply(false);
      } else if (base && Math.abs(e.clientX - base.px) + Math.abs(e.clientY - base.py) > 10) moved = true;
    });
    function up(e) {
      if (!pts[e.pointerId]) return;
      var wasOne = count() === 1;
      delete pts[e.pointerId];
      try { stage.releasePointerCapture(e.pointerId); } catch (x) {}
      if (count() === 1) { var k = Object.keys(pts)[0]; base = { px: pts[k].x, py: pts[k].y, x: G.x, y: G.y }; }
      else if (count() === 0) base = null;
      if (G.s < 1.05) { G.s = 1; G.x = 0; G.y = 0; gApply(true); }
      if (wasOne && !moved && e.type === 'pointerup') {
        var now = Date.now();
        if (now - lastTap < 320 && Math.hypot(e.clientX - tapX, e.clientY - tapY) < 30) {
          lastTap = 0;
          if (G.s > 1.01) { G.s = 1; G.x = 0; G.y = 0; } else { G.s = 2.5; G.x = 0; G.y = 0; }
          gApply(true);
        } else { lastTap = now; tapX = e.clientX; tapY = e.clientY; }
      }
    }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
  }
  function size() {
    var nat = st.img.naturalWidth || 1400;
    var narrow = window.innerWidth < 760;
    var s = narrow ? Math.min(nat, window.innerWidth - 48, window.innerHeight - 210) : Math.min(nat, window.innerHeight - 200, window.innerWidth - 104);
    zm.style.setProperty('--zm-size', Math.max(240, Math.round(s)) + 'px');
    stripState();
  }
  function stripState() {
    var over = st.strip.scrollWidth > st.strip.clientWidth + 1;
    st.tp.hidden = !over; st.tn.hidden = !over;
    st.tp.disabled = st.strip.scrollLeft <= 1;
    st.tn.disabled = st.strip.scrollLeft >= st.strip.scrollWidth - st.strip.clientWidth - 1;
  }
  function show(i) {
    var n = st.items.length; if (i < 0 || i > n - 1) return;
    st.i = i;
    var it = st.items[i];
    gReset();
    st.img.classList.add('is-loading');
    st.img.alt = it.alt;
    st.img.src = it.src;
    if (st.img.complete && st.img.naturalWidth) { st.img.classList.remove('is-loading'); size(); }
    st.prev.disabled = i === 0; st.next.disabled = i === n - 1;
    Array.prototype.forEach.call(st.strip.children, function (b, k) { b.classList.toggle('is-active', k === i); });
    var t = st.strip.children[i];
    if (t) {
      var l = t.offsetLeft, r = l + t.offsetWidth;
      if (l < st.strip.scrollLeft) st.strip.scrollTo({ left: l, behavior: 'smooth' });
      else if (r > st.strip.scrollLeft + st.strip.clientWidth) st.strip.scrollTo({ left: r - st.strip.clientWidth, behavior: 'smooth' });
    }
  }
  function open(root, index) {
    if (!zm) build();
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pg-track] .lj-slide'));
    var thumbs = root.querySelectorAll('[data-pg-thumb] img');
    st.items = slides.map(function (s) {
      var im = s.querySelector('img');
      return { src: s.getAttribute('data-zoom') || (im && (im.currentSrc || im.src)) || '', alt: im ? (im.getAttribute('alt') || '') : '' };
    });
    st.root = root;
    zm.style.cssText = root.getAttribute('style') || '';
    st.strip.innerHTML = '';
    st.items.forEach(function (it, k) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'lj-zm__th'; b.setAttribute('aria-label', 'Foto ' + (k + 1));
      var im = document.createElement('img'); var ts = thumbs[k] ? (thumbs[k].currentSrc || thumbs[k].src) : it.src; im.src = ts; im.alt = '';
      b.appendChild(im); b.addEventListener('click', function () { show(k); }); st.strip.appendChild(b);
    });
    zm.classList.toggle('is-single', st.items.length < 2);
    st.opener = document.activeElement;
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    zm.hidden = false;
    size();
    show(index);
    requestAnimationFrame(function () { zm.classList.add('is-open'); });
    zm.querySelector('.lj-zm__close').focus();
  }
  function close() {
    if (!zm || zm.hidden) return;
    zm.classList.remove('is-open');
    setTimeout(function () {
      zm.hidden = true;
      document.documentElement.style.overflow = '';
      document.body.style.paddingRight = '';
      if (st.opener && st.opener.focus) st.opener.focus();
    }, 350);
  }
  document.addEventListener('click', function (e) {
    var slide = e.target.closest && e.target.closest('.lj-pg[data-pg-zoom] .lj-slide');
    if (!slide) return;
    var root = slide.closest('.lj-pg');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pg-track] .lj-slide'));
    open(root, Math.max(0, slides.indexOf(slide)));
  });
})();


/* ===== v0.16 prezzo 0 + totale nel bottone: prezzo 0 = carrello bloccato finché Easify non ha un totale > 0; prezzo > 0 = prezzo + opzioni dentro il bottone ===== */
(function () {
  function parse(text) {
    var m = text.match(/\d[\d.,]*/g); if (!m) return null;
    var raw = m[m.length - 1], s = raw;
    var lc = s.lastIndexOf(','), ld = s.lastIndexOf('.');
    if (lc > -1 && ld > -1) { s = lc > ld ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, ''); }
    else if (lc > -1) { s = /,\d{1,2}$/.test(s) ? s.replace(',', '.') : s.replace(/,/g, ''); }
    else if (ld > -1) { s = /\.\d{1,2}$/.test(s) ? s : s.replace(/\./g, ''); }
    var v = parseFloat(s);
    return isNaN(v) ? null : v;
  }
  function easifyTotal(root) {
    var best = null;
    Array.prototype.forEach.call(root.querySelectorAll('div,span,p,b,strong,label,td,li'), function (el) {
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (t.length > 80 || !/^(total price|prezzo totale|totale)\b/i.test(t)) return;
      var inner = false;
      Array.prototype.forEach.call(el.children, function (c) {
        var ct = (c.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^(total price|prezzo totale|totale)\b/i.test(ct) && parse(ct) !== null) inner = true;
      });
      if (inner) return;
      var v = parse(t);
      if (v !== null) best = { value: v, el: el, raw: t.replace(/^(total price|prezzo totale|totale)\s*:?\s*/i, '') };
    });
    return best;
  }
  function visible(el) {
    if (el.closest('[hidden]') || el.disabled) return false;
    var st = window.getComputedStyle(el);
    if (st.display === 'none' || st.visibility === 'hidden') return false;
    var p = el.parentElement;
    while (p && p.nodeType === 1) { if (window.getComputedStyle(p).display === 'none') return false; p = p.parentElement; }
    return true;
  }
  function requiredMissing(sec) {
    var seen = {}, missing = false;
    Array.prototype.forEach.call(sec.querySelectorAll('input[data-required="1"]'), function (el) {
      if (missing) return;
      var c = el.closest('.tpo_option-container') || el.parentElement;
      if (!c || c.classList.contains('tpo_hidden') || !visible(c)) return;
      if (!String(el.value || '').trim()) missing = true;
    });
    if (missing) return true;
    Array.prototype.forEach.call(sec.querySelectorAll('input[required],select[required],textarea[required],[aria-required="true"]'), function (el) {
      if (missing || el.closest('.lj-buy') || el.closest('[data-option]')) return;
      var tag = el.tagName, type = (el.getAttribute('type') || '').toLowerCase();
      if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') {
        if (type === 'hidden') return;
        if (type !== 'radio' && !visible(el)) return;
        if (type === 'radio') {
          var name = el.name || ''; if (seen[name]) return; seen[name] = 1;
          var group = sec.querySelectorAll('input[type="radio"][name="' + name.replace(/"/g, '\\"') + '"]');
          var any = false, vis = false;
          Array.prototype.forEach.call(group, function (r) { if (r.checked) any = true; if (visible(r) || (r.parentElement && visible(r.parentElement))) vis = true; });
          if (vis && !any) missing = true;
        } else if (type === 'checkbox') { if (!el.checked) missing = true; }
        else if (type === 'file') { if (!el.files || !el.files.length) missing = true; }
        else if (!String(el.value || '').trim()) missing = true;
      } else {
        if (!visible(el)) return;
        if (!el.querySelector('input:checked,[aria-checked="true"],[aria-selected="true"]') && el.getAttribute('aria-checked') !== 'true') missing = true;
      }
    });
    return missing;
  }
  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  // il riquadro che contiene SOLO il totale di Easify (così si nasconde anche il bordo)
  function totalBox(el) {
    var box = el, txt = norm(el.textContent);
    for (var i = 0; i < 4; i++) {
      var p = box.parentElement;
      if (!p || p.matches('body,form,[data-product-section],.lj-product__info,.lj-block,.tpo_option-set-container')) break;
      if (norm(p.textContent) !== txt || p.querySelector('input,button,select,textarea,img')) break;
      box = p;
    }
    return box;
  }
  function showTotal(el, show) {
    var box = totalBox(el);
    if (el.__ljBox && el.__ljBox !== box) el.__ljBox.classList.remove('lj-eo-hide');
    el.__ljBox = box;
    box.classList.toggle('lj-eo-hide', !show);
    if (show) box.removeAttribute('aria-hidden'); else box.setAttribute('aria-hidden', 'true');
  }
  // formatta un importo con lo stesso stile di un prezzo di esempio (es. "€27,50")
  function fmt(sample, v) {
    var m = String(sample || '').match(/^(.*?)(\d[\d.,\s]*\d|\d)(.*)$/);
    var s = v.toFixed(2), ip = s.split('.')[0], fp = s.split('.')[1];
    if (!m) return s;
    var num = m[2], dec = /[.,]\d{2}$/.test(num) ? num.slice(-3, -2) : ',';
    var th = dec === ',' ? '.' : ',';
    if (ip.length > 3) ip = ip.replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return m[1] + ip + dec + fp + m[3];
  }
  function baseOf(sec, btn) {
    var cents = parseInt(btn.getAttribute('data-cents'), 10), money = btn.getAttribute('data-money') || '';
    var form = btn.closest('form'), idIn = form && form.querySelector('input[name="id"]');
    var dataEl = sec.querySelector('[data-variants]');
    if (idIn && dataEl) {
      try {
        var vs = sec.__ljVs || (sec.__ljVs = JSON.parse(dataEl.textContent));
        for (var i = 0; i < vs.length; i++) {
          if (String(vs[i].id) === String(idIn.value)) { if (vs[i].cents != null) cents = vs[i].cents; if (vs[i].price) money = vs[i].price; break; }
        }
      } catch (e) {}
    }
    return { cents: cents, money: money };
  }
  // true se almeno un'opzione di Easify è davvero scelta (guardo i campi "properties[...]" che finiscono nel carrello)
  function anySelected(sec) {
    var fields = sec.querySelectorAll('.tpo_option-set-container input[name^="properties["]');
    if (!fields.length) return true;
    var found = false;
    Array.prototype.forEach.call(fields, function (el) {
      if (found) return;
      var c = el.closest('.tpo_option-container');
      if (c && c.classList.contains('tpo_hidden')) return;
      var t = (el.getAttribute('type') || '').toLowerCase();
      if ((t === 'checkbox' || t === 'radio') && !el.checked) return;
      if (String(el.value || '').trim()) found = true;
    });
    return found;
  }
  function decorate(el) {
    if (!el.classList.contains('lj-eo-total')) el.classList.add('lj-eo-total');
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      if (/total price|prezzo totale/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/total price|prezzo totale/i, 'Totale');
    }
  }
  function refreshSection(sec) {
    var tot = easifyTotal(sec);
    var btn = sec.querySelector('[data-add]');
    var zero = !!btn && btn.getAttribute('data-zero') === 'true';
    if (tot && tot.el) { decorate(tot.el); showTotal(tot.el, zero); }   // il "Totale" di Easify si vede solo coi prodotti a prezzo 0
    // il totale conta solo se Easify lo mostra e almeno un'opzione è scelta (niente valori "vecchi" dopo aver deselezionato)
    var tv = (tot && tot.value > 0 && visible(tot.el) && anySelected(sec)) ? tot.value : 0;
    if (!btn || btn.getAttribute('data-avail') === 'false') return;
    if (!zero) {
      // prezzo > 0: dentro il bottone = prezzo del prodotto + totale delle opzioni
      var b = baseOf(sec, btn);
      if (isNaN(b.cents)) return;
      var base = b.cents / 100, opts = tv;
      var incl = btn.getAttribute('data-eo-incl') === 'true';
      var price = opts ? fmt(b.money, incl ? Math.max(opts, base) : base + opts) : b.money;
      window.ljSetAdd(btn, btn.getAttribute('data-label') || '', price);
      return;
    }
    var hasTot = tv > 0;
    var miss = hasTot && requiredMissing(sec);
    var ok = hasTot && !miss;
    var text = miss ? (btn.getAttribute('data-required-label') || btn.getAttribute('data-zero-label') || '') : (btn.getAttribute('data-zero-label') || '');
    if (ok) { if (btn.hasAttribute('data-blocked')) btn.removeAttribute('data-blocked'); }
    else if (btn.getAttribute('data-blocked') !== 'true') btn.setAttribute('data-blocked', 'true');
    if (btn.disabled === ok) btn.disabled = !ok;
    if (ok) window.ljSetAdd(btn, btn.getAttribute('data-label') || '', tot ? tot.raw : '');
    else window.ljSetAdd(btn, text);
  }
  function refreshAll() { document.querySelectorAll('[data-product-section]').forEach(refreshSection); }
  window.ljZeroRefresh = refreshAll;
  var raf;
  function schedule() { cancelAnimationFrame(raf); raf = requestAnimationFrame(refreshAll); }
  function watch(sec) {
    if (sec.__zw) return; sec.__zw = true;
    new MutationObserver(schedule).observe(sec, { childList: true, subtree: true, characterData: true });
  }
  function init() { document.querySelectorAll('[data-product-section]').forEach(watch); refreshAll(); setTimeout(refreshAll, 1200); setTimeout(refreshAll, 3000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('input', schedule, true);
  document.addEventListener('change', schedule, true);
  // le opzioni radio si possono togliere con un altro clic senza evento "change": ricontrollo dopo ogni clic e ogni tanto
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.tpo_option-set-container')) { schedule(); setTimeout(refreshAll, 150); setTimeout(refreshAll, 600); }
  }, true);
  setInterval(function () { if (!document.hidden && document.querySelector('.tpo_option-set-container')) refreshAll(); }, 800);
  function blocked(form) { return !!(form && form.querySelector && form.querySelector('[data-add][data-blocked="true"]')); }
  document.addEventListener('submit', function (e) {
    if (blocked(e.target)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-add][data-blocked="true"]');
    if (b) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
})();

/* ===== v0.17 Recensioni app (Joy / Avada): stile del sito, badge "Verificato" intatto =====
   Non servono classi: il widget viene riconosciuto dal contenuto (stelle + testo "recensioni")
   e ogni elemento riceve un ruolo (titolo, nome, testo, data, bottone...) in base all'aspetto. */
(function(){
  'use strict';
  if(window.__ljRevApp)return;window.__ljRevApp=1;
  if(document.documentElement.classList.contains('lj-quick'))return;

  /* ---------- CSS (letto dai token del tema: --lj-ink, --lj-gold, --lj-line, --lj-muted ...) ---------- */
  var INH=['h1','h2','score','name','body','meta','link','btn','btn2'].map(function(r){
    return '[data-lj-r="'+r+'"] :where(*:not([data-lj-keep]):not([data-lj-keep] *):not(svg):not(svg *))';
  }).join(',');
  var CSS=[
    INH+'{font:inherit!important;color:inherit!important;letter-spacing:inherit!important;text-transform:inherit!important}',
    '[data-lj-probe]{transition:none!important;animation:none!important}',
    '[data-lj-b]{background:var(--lj-rev-box,var(--lj-sand,#EEE7DD))!important;border:0!important;border-radius:0!important;box-shadow:none!important}',
    '[data-lj-r="h1"]{font:400 clamp(26px,2.4vw,34px)/1.1 var(--lj-serif)!important;letter-spacing:-.005em!important;color:var(--lj-ink)!important;text-transform:none!important}',
    '[data-lj-r="h2"]{font:400 clamp(20px,1.8vw,24px)/1.2 var(--lj-serif)!important;letter-spacing:-.005em!important;color:var(--lj-ink)!important;text-transform:none!important}',
    '[data-lj-r="score"]{font:400 40px/1 var(--lj-serif)!important;color:var(--lj-ink)!important;letter-spacing:0!important}',
    '[data-lj-r="name"]{font:600 13px/1.4 var(--lj-sans)!important;color:var(--lj-ink)!important;letter-spacing:0!important;text-transform:none!important}',
    '[data-lj-r="body"]{font:400 var(--lj-body,14px)/1.7 var(--lj-sans)!important;color:var(--lj-text,var(--lj-ink))!important;letter-spacing:0!important;text-transform:none!important}',
    '[data-lj-r="meta"]{font:400 12px/1.5 var(--lj-sans)!important;color:var(--lj-muted)!important;letter-spacing:.01em!important;text-transform:none!important}',
    '[data-lj-r="link"]{font:500 12.5px/1.45 var(--lj-sans)!important;color:var(--lj-ink)!important;letter-spacing:0!important;text-transform:none!important;text-decoration:underline!important;text-decoration-color:var(--lj-line)!important;text-underline-offset:3px}',
    '[data-lj-r="link"]:hover{text-decoration-color:var(--lj-ink)!important}',
    '[data-lj-ic]{color:var(--lj-rev-star,var(--lj-gold))!important}',
    '[data-lj-r="startxt"]{color:var(--lj-rev-star,var(--lj-gold))!important}',
    '[data-lj-r="star"]{fill:var(--lj-rev-star,var(--lj-gold))!important}',
    '[data-lj-r="starS"]{stroke:var(--lj-rev-star,var(--lj-gold))!important}',
    '[data-lj-r="btn"]{background:var(--lj-ink)!important;color:#fff!important;border:1px solid var(--lj-ink)!important;border-radius:0!important;box-shadow:none!important;font:500 11px/1 var(--lj-sans)!important;letter-spacing:.1em!important;text-transform:uppercase!important;text-decoration:none!important;padding:15px 26px!important;transition:background .4s var(--lj-ease,ease),border-color .4s var(--lj-ease,ease)}',
    '[data-lj-r="btn"]:hover{background:var(--lj-gold-dark)!important;border-color:var(--lj-gold-dark)!important;color:#fff!important}',
    '[data-lj-r="btn2"]{background:#fff!important;color:var(--lj-ink)!important;border:1px solid var(--lj-line)!important;border-radius:0!important;box-shadow:none!important;font:500 11px/1 var(--lj-sans)!important;letter-spacing:.08em!important;text-transform:uppercase!important;text-decoration:none!important;padding:11px 16px!important;transition:border-color .4s var(--lj-ease,ease)}',
    '[data-lj-r="btn2"]:hover{border-color:var(--lj-ink)!important;color:var(--lj-ink)!important}',
    '[data-lj-r="btni"]{background:var(--lj-ink)!important;color:#fff!important;border:1px solid var(--lj-ink)!important;border-radius:0!important;box-shadow:none!important;padding:11px 14px!important}',
    '[data-lj-r="btn2i"]{background:#fff!important;color:var(--lj-ink)!important;border:1px solid var(--lj-line)!important;border-radius:0!important;box-shadow:none!important;padding:11px 14px!important;transition:border-color .4s var(--lj-ease,ease)}',
    '[data-lj-r="btn2i"]:hover{border-color:var(--lj-ink)!important}',
    '[data-lj-r="avatar"]{background:var(--lj-line)!important;color:var(--lj-ink)!important;font:600 13px/1 var(--lj-sans)!important;letter-spacing:0!important}',
    '[data-lj-r="field"]{font:400 13px/1.5 var(--lj-sans)!important;color:var(--lj-ink)!important;background:#fff!important;border:1px solid var(--lj-line)!important;border-radius:0!important;box-shadow:none!important;padding:11px 14px!important}',
    '[data-lj-r="field"]:focus{border-color:var(--lj-ink)!important;outline:0!important}'
  ].join('\n');

  /* ---------- utilità ---------- */
  var LASTTXT=0;
  var DONE=new WeakSet(),KEEP=new WeakSet(),SUB=new WeakSet(),ROLE=new WeakMap(),
      STATE=new WeakMap(),OBS=new WeakSet(),STY=new WeakSet(),CHK=new WeakMap(),ROOTS=[];
  var SKIPTAG={script:1,style:1,noscript:1,template:1,iframe:1,canvas:1,video:1,audio:1,img:1,picture:1,br:1,hr:1};
  var TEXTR={h1:1,h2:1,score:1,name:1,body:1,meta:1,link:1};
  var BADGE=/^[\s✓✔☑]*(?:(?:acquisto|acquirente|cliente|buyer|purchase|customer)\s+)?(?:verificat[oa]|verified|vérifi[ée]e?|verifiziert|verificad[oa])(?:\s+(?:buyer|purchase|customer|acquirente|acquisto|cliente|acheteur))?[\s✓✔☑]*$/i;
  var REVRX=/recension|review|avis|bewertung|reseñ|valutazion|opinion/i;
  var WRITE=/(scrivi|scrivere|lascia|aggiungi|write|leave|add)\s+(una\s+|la\s+tua\s+|a\s+|your\s+)?(recension|review)/i;
  var LOYAL=/loyalty|reward|launcher|referral|vip|points/i;
  var COUNT=/\d+\s*(recension|review|avis|bewertung)/i;
  var SEEDS='[data-lj-reviews],[class*="avada" i],[id*="avada" i],[class*="joy" i],[id*="joy" i],[class*="review" i],[id*="review" i],.shopify-app-block,[id^="shopify-block-"],.lj-block>*,.shopify-section>*,.shopify-section>*>*,.shopify-section>*>*>*';

  function rgb(s){var m=/rgba?\(([^)]+)\)/.exec(s||'');if(!m)return null;var t=m[1].split(/[\s,\/]+/).filter(Boolean);if(t.length<3)return null;var a=1;if(t[3]!==undefined){a=parseFloat(t[3]);if(/%$/.test(t[3]))a/=100}return{r:+t[0],g:+t[1],b:+t[2],a:a}}
  function hsl(c){var r=c.r/255,g=c.g/255,b=c.b/255,mx=Math.max(r,g,b),mn=Math.min(r,g,b),l=(mx+mn)/2,h=0,s=0,d=mx-mn;if(d){s=d/(1-Math.abs(2*l-1));h=mx===r?((g-b)/d)%6:mx===g?(b-r)/d+2:(r-g)/d+4;h*=60;if(h<0)h+=360}return{h:h,s:s,l:l}}
  function yellow(c){if(!c||c.a<.3)return false;var o=hsl(c);return o.h>=20&&o.h<=62&&o.s>=.45&&o.l>=.3&&o.l<=.8}
  function own(el){var s='';for(var n=el.firstChild;n;n=n.nextSibling)if(n.nodeType===3)s+=n.nodeValue;s=s.replace(/\s+/g,' ').trim();if(!s&&el.localName==='input')s=el.value||'';return s}
  function cls(el){return el.getAttribute&&el.getAttribute('class')||''}

  var PUA=/[\uE000-\uF8FF]/;
  var ICONFF=/icon|awesome|glyph|material|feather|fontello|dashicon|swiper|remix|lucide|ionic|themify|linearicons|elegant|simple-line|typicons|entypo|et-line|icomoon|^fa[sbrld]?$|^fa[\s-]|pe-7|boxicons|bootstrap/i;
  var COMMON=/^(arial|helvetica|inter|system-ui|-apple-system|blinkmacsystemfont|segoe ui|roboto|sans-serif|serif|georgia|times|verdana|tahoma|open sans|lato|montserrat|poppins|nunito|sf pro|instrument serif|monospace|ui-sans-serif)/i;
  function fam(cs){return (cs.fontFamily||'').split(',')[0].replace(/["']/g,'').trim()}
  function isIcon(c,cs){
    var f=fam(cs),t=own(c);
    if(PUA.test(t))return true;
    if(f&&ICONFF.test(f))return true;
    if(t&&t.length<=2&&f&&!COMMON.test(f)&&c.parentElement&&fam(getComputedStyle(c.parentElement))!==f)return true;
    var ps=['::before','::after'];
    for(var i=0;i<2;i++){
      var p=getComputedStyle(c,ps[i]),ct=p.content;
      if(ct&&ct!=='none'&&ct!=='normal'&&(PUA.test(ct)||ICONFF.test(fam(p))))return true;
    }
    return false;
  }
  function iconsIn(root,ops){
    [].slice.call(root.querySelectorAll('*')).forEach(function(e){
      if(DONE.has(e)||SKIPTAG[e.localName]||e.localName==='svg'||e.closest('svg'))return;
      DONE.add(e);var cs=getComputedStyle(e);
      if(isIcon(e,cs)){KEEP.add(e);ops.push([e,'keep']);if(yellow(rgb(cs.color)))ops.push([e,'ic'])}
    });
  }
  function ensure(sr){
    if(STY.has(sr))return;STY.add(sr);
    var s=document.createElement('style');s.setAttribute('data-lj-rev','');s.textContent=CSS;sr.appendChild(s);
  }
  function observe(node,top){
    if(OBS.has(node))return;OBS.add(node);var t,t2;
    new MutationObserver(function(){clearTimeout(t);clearTimeout(t2);t=setTimeout(function(){run(top);t2=setTimeout(function(){run(top)},700)},120)})
      .observe(node,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','hidden','open','aria-hidden']});
  }
  function kids(n,top){
    var a=[],c;
    for(c=n.firstElementChild;c;c=c.nextElementSibling)a.push(c);
    if(n.shadowRoot){
      if(top){ensure(n.shadowRoot);observe(n.shadowRoot,top)}
      for(c=n.shadowRoot.firstElementChild;c;c=c.nextElementSibling)if(c.localName!=='style')a.push(c);
    }
    return a;
  }
  function flat(el){var out=[];(function w(n){kids(n).forEach(function(c){out.push(c);w(c)})})(el);return out}

  /* ---------- riconoscimento ruoli ---------- */
  function isBadge(c){
    if(c.childElementCount>4)return false;
    var t=(c.textContent||'');if(t.length>40)return false;
    t=t.replace(/\s+/g,' ').trim();if(!t)return false;
    return BADGE.test(t)||/verif/i.test(cls(c)+' '+(c.id||''));
  }
  function isBtn(c,cs,bg){
    var tag=c.localName;
    var t=(c.textContent||'').trim()||(tag==='input'?c.value:'');
    if(!t||t.length>40)return false;
    if(c.querySelector&&c.querySelector('img,picture,a,button'))return false;
    if(tag==='input')return /^(submit|button)$/i.test(c.type);
    var hasBg=bg&&bg.a>.1&&hsl(bg).l<.985;
    var bw=parseFloat(cs.borderTopWidth)+parseFloat(cs.borderRightWidth)+parseFloat(cs.borderBottomWidth)+parseFloat(cs.borderLeftWidth);
    var hasBd=bw>0&&cs.borderTopStyle!=='none';
    var pad=parseFloat(cs.paddingLeft)+parseFloat(cs.paddingRight);
    var clicky=tag==='button'||tag==='a'||c.getAttribute('role')==='button'||cs.cursor==='pointer';
    return clicky&&(hasBg||hasBd)&&pad>=12;
  }
  /* i bottoni già stilati (es. numeri di pagina) cambiano aspetto quando il widget cambia stato (pagina corrente, attivo…):
     tolgo un istante il nostro ruolo, leggo l'aspetto originale dell'app e riassegno scuro / chiaro */
  var BTNR=/^btn2?i?$/;
  function reBtn(c){
    var r=c.getAttribute&&c.getAttribute('data-lj-r');
    if(!r||!BTNR.test(r))return;
    c.setAttribute('data-lj-probe','');c.removeAttribute('data-lj-r');     /* probe = senza transizioni, così leggo subito il colore vero */
    var cs=getComputedStyle(c),bg=rgb(cs.backgroundColor),txt=own(c),
        prim=bg&&bg.a>.1&&hsl(bg).l<.93,tiny=txt.length<=2||PUA.test(txt)||(c.textContent||'').trim().length<=2;
    c.removeAttribute('data-lj-probe');c.setAttribute('data-lj-r',(prim?'btn':'btn2')+(tiny?'i':''));
  }
  function isAvatar(c,cs,txt){
    if(!txt||txt.length>3)return false;
    var w=c.offsetWidth,h=c.offsetHeight;if(!w||w>64||Math.abs(w-h)>2)return false;
    var br=cs.borderTopLeftRadius;
    return /%/.test(br)?parseFloat(br)>=40:parseFloat(br)>=w/2-1;
  }
  function textRole(c,cs,txt,parentRole){
    var tag=c.localName,fs=parseFloat(cs.fontSize)||14,fw=parseInt(cs.fontWeight,10)||400;
    if(/^[★☆✭✮⭐\s]+$/.test(txt))return 'startxt';
    if(/^\d+([.,]\d+)?$/.test(txt)&&fs>=22)return 'score';
    if(cs.display==='inline'&&tag!=='a'&&parentRole&&TEXTR[parentRole])return null;   /* figlio inline: eredita */
    if((/^h[1-4]$/.test(tag)&&fs>=15)||(fs>=18&&fw>=500)||fs>=24)return 'head';
    if(tag==='a')return 'link';
    var col=rgb(cs.color);
    if(col){var o=hsl(col);if(o.s<.18&&o.l>.35&&o.l<.8)return 'meta'}
    if(fs<=12.5)return 'meta';
    if(fw>=600&&fs<=17)return 'name';
    return 'body';
  }
  function starify(svg,ops){
    var all=[svg].concat([].slice.call(svg.querySelectorAll('*')));
    all.forEach(function(e){
      DONE.add(e);var cs=getComputedStyle(e);
      if(yellow(rgb(cs.fill)))ops.push([e,'star']);
      if(yellow(rgb(cs.stroke)))ops.push([e,'starS']);
    });
  }

  function walk(node,top,ops,parentRole){
    kids(node,top).forEach(function(c){
      var tag=c.localName;
      if(SKIPTAG[tag]||KEEP.has(c))return;
      if(DONE.has(c)){reBtn(c);if(!SUB.has(c))walk(c,top,ops,ROLE.get(c)||parentRole);return}
      if(isBadge(c)){DONE.add(c);KEEP.add(c);ops.push([c,'keep']);return}
      var cs=getComputedStyle(c);
      if(cs.display==='none')return;
      DONE.add(c);
      if(tag==='svg'){SUB.add(c);starify(c,ops);return}
      if(tag==='input'||tag==='textarea'||tag==='select'){
        var ty=(c.type||'').toLowerCase();
        if(tag==='input'&&/^(submit|button)$/.test(ty)){/* bottone: sotto */}
        else{
          if(tag!=='input'||/^(text|email|search|tel|url|password|number)$/.test(ty)){SUB.add(c);ops.push([c,'field'])}
          return;
        }
      }
      var bg=rgb(cs.backgroundColor),txt=own(c),theme=/(^|\s)lj-/.test(cls(c));
      if(!theme&&isBtn(c,cs,bg)){
        var prim=bg&&bg.a>.1&&hsl(bg).l<.93,tiny=txt.length<=2||PUA.test(txt)||(c.textContent||'').trim().length<=2;
        SUB.add(c);ops.push([c,(prim?'btn':'btn2')+(tiny?'i':'')]);iconsIn(c,ops);return;
      }
      if(isIcon(c,cs)){KEEP.add(c);ops.push([c,'keep']);if(yellow(rgb(cs.color)))ops.push([c,'ic']);return}
      if(!theme&&isAvatar(c,cs,txt)){SUB.add(c);ops.push([c,'avatar']);iconsIn(c,ops);return}
      if(!theme&&bg&&bg.a>.5&&cs.display!=='inline'){var l=hsl(bg).l;if(l>=.7&&l<.985)ops.push([c,'box'])}
      var role=null;
      if(!theme&&txt){
        role=textRole(c,cs,txt,parentRole);
        if(role==='head'){ops.push([c,'head',parseFloat(cs.fontSize)||0]);ROLE.set(c,'h2')}
        else if(role){ops.push([c,role]);ROLE.set(c,role)}
      }
      walk(c,top,ops,role==='head'?'h2':(role||parentRole));
    });
  }

  function run(top){
    var ops=[],st=STATE.get(top);if(!st){st={h1:0};STATE.set(top,st)}
    walk(top,top,ops,null);
    var heads=ops.filter(function(o){return o[1]==='head'}),h1=null;
    if(!st.h1&&heads.length){h1=heads.reduce(function(a,b){return b[2]>a[2]?b:a});st.h1=1}
    ops.forEach(function(o){
      var r=o[1];
      if(r==='head'){r=(o===h1)?'h1':'h2';ROLE.set(o[0],r)}
      if(r==='keep')o[0].setAttribute('data-lj-keep','');
      else if(r==='ic')o[0].setAttribute('data-lj-ic','');
      else if(r==='box')o[0].setAttribute('data-lj-b','');
      else o[0].setAttribute('data-lj-r',r);
    });
  }

  /* ---------- ricerca del widget ---------- */
  function loyal(el){for(var i=0;el&&i<14;i++,el=el.parentElement)if(LOYAL.test(cls(el)+' '+(el.id||'')+' '+el.localName))return true;return false}
  function why(el){
    if(el===document.body||el===document.documentElement)return 'body';
    if(/(^|\s)lj-/.test(cls(el)))return 'classe del tema';
    if(el.matches('.shopify-section,[id^="shopify-section"]'))return 'sezione';
    if(el.closest('header,footer,nav'))return 'dentro header/footer/nav';
    if(el.querySelector('[class^="lj-"],[class*=" lj-"]'))return 'contiene elementi del tema (lj-)';
    if(el.querySelector('form[action*="/cart/add"],main,header,footer'))return 'contiene form carrello/main/header/footer';
    if(loyal(el)||el.querySelector('[class*="loyalty" i],[id*="loyalty" i],[class*="reward" i],[id*="reward" i],[class*="launcher" i],[id*="launcher" i]'))return 'widget fedeltà (escluso)';
    return '';
  }
  function cand(el){return !why(el)}
  function looks(el){
    var now=Date.now(),c=CHK.get(el);if(c&&(c.ok||now-c.t<1500))return c.ok;
    var ok=false;
    if(el.hasAttribute('data-lj-reviews'))ok=true;
    else{
      var f=flat(el);
      if(f.length&&f.length<6000){
        var txt='',star=false;
        for(var i=0;i<f.length&&!((star||COUNT.test(txt))&&REVRX.test(txt));i++){
          var e=f[i];
          if(e.localName==='svg')star=true;
          else{var t=own(e);if(t){if(txt.length<4000)txt+=' '+t;if(/[★☆]/.test(t))star=true}}
          if(!star&&/star|rating/i.test(cls(e)))star=true;
        }
        ok=REVRX.test(txt)&&(star||COUNT.test(txt));
      }
    }
    CHK.set(el,{ok:ok,t:now});return ok;
  }
  function byText(){
    var out=[],w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null),n,k=0;
    while((n=w.nextNode())&&k<4000){
      k++;
      if(n.nodeValue.length>60||!WRITE.test(n.nodeValue))continue;
      var el=n.parentElement;if(!el||/^(script|style|noscript|template)$/.test(el.localName))continue;
      var best=null,i=0;
      while(el&&el!==document.body&&i<16){if(LOYAL.test(cls(el)+' '+(el.id||'')+' '+el.localName)){best=null;break}if(cand(el))best=el;el=el.parentElement;i++}
      if(best&&out.indexOf(best)<0)out.push(best);
    }
    return out;
  }
  function findRoots(){
    var list=[],seen=[],q=[].slice.call(document.querySelectorAll(SEEDS)),all=document.querySelectorAll('*');
    for(var i=0;i<all.length;i++){var n=all[i].localName;if(all[i].shadowRoot||(n.indexOf('-')>0&&/review|joy|avada/.test(n)))q.push(all[i])}
    var custom=window.LJ_REVIEWS_SELECTOR;if(custom){try{q=q.concat([].slice.call(document.querySelectorAll(custom)))}catch(e){}}
    q.slice(0,500).forEach(function(el){if(seen.indexOf(el)<0){seen.push(el);if(cand(el)&&looks(el))list.push(el)}});
    if(!list.length){var now=Date.now();if(now-LASTTXT>1200){LASTTXT=now;byText().forEach(function(el){if(list.indexOf(el)<0)list.push(el)})}}
    return list.filter(function(a){return !list.some(function(b){return b!==a&&b.contains(a)})});
  }
  function scan(){
    findRoots().forEach(function(r){
      if(ROOTS.indexOf(r)<0){ROOTS.push(r);observe(r,r)}
      run(r);
    });
  }

  window.ljRevDebug=function(){
    var info={script:'caricato',radici:ROOTS.length,elementiStilati:(function(){var n=0;ROOTS.forEach(function(r){flat(r).forEach(function(e){if(e.hasAttribute('data-lj-r'))n++})});return n})()};
    if(!ROOTS.length){
      var a=[],w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null),n;
      while((n=w.nextNode())){
        if(n.nodeValue.length>60||!WRITE.test(n.nodeValue))continue;
        var el=n.parentElement,chain=[],i=0;
        while(el&&el!==document.body&&i<16){chain.push(el.localName+(el.id?'#'+el.id:'')+(cls(el)?'.'+cls(el).trim().split(/\s+/).slice(0,3).join('.'):'')+' => '+(why(el)||'OK'));el=el.parentElement;i++}
        a.push({testo:n.nodeValue.trim(),catena:chain});
      }
      info.pulsanteTrovato=a.length?a:'nessun testo "Scrivi una recensione" nel DOM normale (iframe o shadow DOM?)';
      info.iframe=[].map.call(document.querySelectorAll('iframe'),function(f){return (f.id||'')+' '+(f.src||'').slice(0,80)}).filter(function(x){return /review|joy|avada|judge/i.test(x)});
    }
    console.log('[lj-rev]',JSON.stringify(info,null,1));
    if(ROOTS.length){
      var rows=[];
      ROOTS.forEach(function(r){flat(r).forEach(function(e){
        var k=e.getAttribute('data-lj-r')||(e.hasAttribute('data-lj-keep')?'KEEP':'')||(e.hasAttribute('data-lj-b')?'box':'');
        if(k)rows.push({ruolo:k,tag:e.localName,classe:cls(e).slice(0,60),testo:(e.textContent||'').trim().slice(0,30)});
      })});
      if(console.table)console.table(rows);
    }
    return info;
  };

  function init(){
    var s=document.createElement('style');s.id='lj-rev-css';s.textContent=CSS;document.head.appendChild(s);
    scan();
    var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(scan,350)}).observe(document.body,{childList:true,subtree:true});
    [1200,3500,8000].forEach(function(d){setTimeout(scan,d)});
    document.addEventListener('shopify:section:load',function(){setTimeout(scan,200)});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();


/* ===== v0.18 Joy punti: toglie il link "Unisciti a noi per ricevere" ===== */
(function () {
  'use strict';
  /* non agire nella pagina del programma fedeltà (/pages/programma-fedelta, anche con ?view=fidelty) */
  if (/\/programma-fedelta|[?&]view=fidel/i.test(location.pathname + location.search)) return;
  if (window.__ljNoJoin) return; window.__ljNoJoin = 1;

  /* testi da nascondere (aggiungine altri se serve) — vengono nascosti solo dentro un blocco che parla di "punti" */
  var HIDE = [/^\s*unisciti a noi( per (ricevere|guadagnare))?\s*[.!]?\s*$/i, /^\s*join us( to (earn|receive|get))?\s*[.!]?\s*$/i];
  var PHRASE = /\s*unisciti a noi per (ricevere|guadagnare)\s*[.!]?/i;

  function norm(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
  function isPoints(el) {                       /* siamo dentro al calcolatore punti? */
    for (var i = 0, p = el; p && i < 6; i++, p = p.parentElement || (p.getRootNode && p.getRootNode().host)) {
      var t = p.textContent || '';
      if (t.length < 500 && /\bpunt[io]\b|\bpoints?\b/i.test(t)) return true;
    }
    return false;
  }
  function hide(el) { el.style.setProperty('display', 'none', 'important'); el.setAttribute('data-lj-hidden', ''); }

  function scan(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, hits = [];
    while ((n = w.nextNode())) {
      var v = n.nodeValue; if (!v || v.length > 200) continue;
      var el = n.parentElement; if (!el || el.hasAttribute('data-lj-hidden') || /^(script|style|noscript|template)$/i.test(el.localName)) continue;
      if (el.closest && el.closest('[data-lj-hidden]')) continue;
      var exact = HIDE.some(function (r) { return r.test(v); });
      if (exact) { hits.push([n, el, true]); continue; }
      if (PHRASE.test(v)) hits.push([n, el, false]);
    }
    hits.forEach(function (h) {
      var n = h[0], el = h[1];
      if (!isPoints(el)) return;
      if (h[2]) {                                /* il testo è da solo: nascondi il link/contenitore più piccolo che contiene solo lui */
        var t = el, txt = norm(el.textContent);
        while (t.parentElement && norm(t.parentElement.textContent) === txt && t.parentElement !== document.body) t = t.parentElement;
        hide(t);
      } else {                                   /* è dentro una frase più lunga: togli solo quelle parole */
        n.nodeValue = n.nodeValue.replace(PHRASE, '');
      }
    });
    var all = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < all.length; i++) if (all[i].shadowRoot) scan(all[i].shadowRoot);
  }

  function run() { try { scan(document.body); } catch (e) {} }
  var t;
  function later() { clearTimeout(t); t = setTimeout(run, 200); }
  function init() {
    run();
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true, characterData: true });
    [800, 2500, 6000].forEach(function (d) { setTimeout(run, d); });
    document.addEventListener('change', later, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ===== v0.19 Joy punti: icona piccola, in stile sito e centrata (al posto del badge festoso) ===== */
(function () {
  'use strict';
  /* non agire nella pagina del programma fedeltà (/pages/programma-fedelta, anche con ?view=fidelty) */
  if (/\/programma-fedelta|[?&]view=fidel/i.test(location.pathname + location.search)) return;
  if (window.__ljJoyIcon) return; window.__ljJoyIcon = 1;

  /* ---- impostazioni (modificabili qui) ---- */
  var ICON  = 'gift';      /* gift | star | gem | heart | none (none = toglie solo il badge) | original (tiene il badge ma lo rimpicciolisce) */
  var SIZE  = 20;          /* px */
  var GAP   = 10;          /* px tra icona e testo */
  var COLOR = 'var(--lj-gold,#A8844E)';

  var PATHS = {
    gift:  '<rect x="4" y="10" width="24" height="5"/><rect x="6" y="15" width="20" height="12"/><path d="M16 10v17"/><path d="M16 10c-1-4.2-6.5-5.2-6.5-2.6S13 10 16 10z"/><path d="M16 10c1-4.2 6.5-5.2 6.5-2.6S19 10 16 10z"/>',
    star:  '<path d="M16 4l3.6 7.6 8.4 1-6.2 5.8 1.7 8.3L16 22.5 8.5 26.7l1.7-8.3L4 12.6l8.4-1z"/>',
    gem:   '<path d="M9 6h14l5 7-12 14L4 13z"/><path d="M4 13h24"/><path d="M12 13l4 14 4-14"/><path d="M9 6l3 7"/><path d="M23 6l-3 7"/>',
    heart: '<path d="M16 26S5 19.5 5 12.2a5.7 5.7 0 0 1 11-2.4 5.7 5.7 0 0 1 11 2.4C27 19.5 16 26 16 26z"/>'
  };
  /* "Ricevi 37 Punti Fedeltà per l'acquisto di questo articolo." (e varianti) */
  var MSG = /^(ricevi|riceverai|guadagna|guadagnerai|earn|get)\b.{0,40}\bpunt[io]\b/i;

  function norm(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
  function visual(el) { return el.matches && el.matches('img,svg,picture,canvas,[role="img"]'); }
  function hasBg(el) { var b = el.style && el.style.backgroundImage; return b && b !== 'none'; }

  function build() {
    var s = document.createElement('span');
    s.setAttribute('data-lj-joyic', '');
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText = 'flex:none!important;display:block!important;width:' + SIZE + 'px!important;height:' + SIZE + 'px!important;color:' + COLOR + '!important;line-height:0!important';
    s.innerHTML = '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round" focusable="false" style="display:block;width:100%;height:100%">' + PATHS[ICON].replace(/<(\w+)/g, '<$1 vector-effect="non-scaling-stroke"') + '</svg>';
    return s;
  }

  function fix(msg) {
    /* msg = elemento con il testo del messaggio; row = il contenitore che lo tiene insieme al badge */
    var row = msg.parentElement, i = 0;
    while (row && i < 5 && !row.querySelector('img,svg,picture,canvas,[role="img"],[data-lj-joyic]')) { row = row.parentElement; i++; }
    if (!row || row === document.body || norm(row.textContent).length > 280) return;
    if (row.hasAttribute('data-lj-joyrow') && row.querySelector('[data-lj-joyic]') ) return;

    /* il badge originale = immagine/svg dentro la riga, fuori dal testo */
    var olds = [].slice.call(row.querySelectorAll('img,svg,picture,canvas,[role="img"]')).filter(function (e) {
      return !msg.contains(e) && !e.hasAttribute('data-lj-joyic') && !e.closest('[data-lj-joyic]');
    });
    if (!olds.length) {
      [].slice.call(row.querySelectorAll('*')).forEach(function (e) { if (!msg.contains(e) && !norm(e.textContent) && hasBg(e)) olds.push(e); });
    }
    if (!olds.length && ICON !== 'none' && ICON !== 'original') { /* nessun badge: niente da sostituire */ }

    row.setAttribute('data-lj-joyrow', '');
    row.style.setProperty('display', 'flex', 'important');
    row.style.setProperty('align-items', 'center', 'important');
    row.style.setProperty('gap', GAP + 'px', 'important');

    olds.forEach(function (e) {
      if (ICON === 'original') {
        e.style.setProperty('width', SIZE + 'px', 'important'); e.style.setProperty('height', SIZE + 'px', 'important');
        e.style.setProperty('flex', 'none', 'important'); e.style.setProperty('margin', '0', 'important');
      } else {
        e.style.setProperty('display', 'none', 'important'); e.setAttribute('data-lj-hidden', '');
      }
    });
    /* il testo: nessun margine che lo sposti */
    var top = msg; while (top.parentElement && top.parentElement !== row) top = top.parentElement;
    top.style.setProperty('margin-top', '0', 'important'); top.style.setProperty('margin-bottom', '0', 'important');

    if (ICON !== 'none' && ICON !== 'original' && PATHS[ICON] && !row.querySelector('[data-lj-joyic]')) {
      row.insertBefore(build(), row.firstChild);
    }
  }

  function scan(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, seen = [];
    while ((n = w.nextNode())) {
      if (!/punt[io]/i.test(n.nodeValue)) continue;
      var el = n.parentElement; if (!el || /^(script|style|noscript|template)$/i.test(el.localName)) continue;
      /* sali finché il testo dell'elemento è ancora (solo) il messaggio */
      var msg = el;
      while (msg.parentElement && MSG.test(norm(msg.parentElement.textContent)) && norm(msg.parentElement.textContent).length < 200 &&
             !msg.parentElement.querySelector('img,svg,picture,canvas,[role="img"]')) msg = msg.parentElement;
      if (!MSG.test(norm(msg.textContent)) || norm(msg.textContent).length > 200) continue;
      if (seen.indexOf(msg) < 0) { seen.push(msg); fix(msg); }
    }
    var all = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < all.length; i++) if (all[i].shadowRoot) scan(all[i].shadowRoot);
  }

  function run() { try { scan(document.body); } catch (e) {} }
  var t; function later() { clearTimeout(t); t = setTimeout(run, 200); }
  function init() {
    run();
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    [800, 2500, 6000].forEach(function (d) { setTimeout(run, d); });
    document.addEventListener('change', later, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ===== mobile: la pagina non si ingrandisce né si sposta con le dita (solo le foto prodotto, nel popup) ===== */
(function () {
  var touch = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (!touch) return;
  var meta = document.querySelector('meta[name="viewport"]');
  if (meta) meta.setAttribute('content', 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no');
  ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (n) {
    document.addEventListener(n, function (e) { e.preventDefault(); }, { passive: false });
  });
  document.addEventListener('touchmove', function (e) { if (e.touches.length > 1) e.preventDefault(); }, { passive: false });
})();


/* ===== v0.18 variante scelta -> la galleria mostra la foto di quella variante (foto assegnata alla variante in Shopify) ===== */
(function () {
  function found(sec) {
    var dataEl = sec.querySelector('[data-variants]'); if (!dataEl) return null;
    var vs; try { vs = sec.__ljVs || (sec.__ljVs = JSON.parse(dataEl.textContent)); } catch (e) { return null; }
    var key = Array.prototype.map.call(sec.querySelectorAll('[data-option]'), function (g) {
      var c = g.querySelector('input:checked'); return c ? c.value : null;
    }).join('|');
    for (var i = 0; i < vs.length; i++) { if (vs[i].options.join('|') === key) return vs[i]; }
    return null;
  }
  function show(sec, v, instant) {
    if (!v || !v.media) return;
    var track = sec.querySelector('[data-pg-track]'); if (!track || !track.clientWidth) return;
    var slides = track.querySelectorAll('[data-media-id]');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-media-id') === String(v.media)) {
        track.scrollTo({ left: track.scrollLeft + slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: instant ? 'auto' : 'smooth' });
        return;
      }
    }
  }
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest || !t.closest('[data-option]')) return;
    var sec = t.closest('[data-product-section]'); if (!sec) return;
    show(sec, found(sec), false);
  });
  /* arrivo da un link con ?variant=... (o ricarico la pagina): parte già dalla foto di quella variante */
  function first(r) {
    if (document.documentElement.classList.contains('lj-quick') || !/[?&]variant=/.test(location.search)) return;
    var sec = (r || document).querySelector('[data-product-section]'); if (!sec) return;
    show(sec, found(sec), true);
  }
  first();
  document.addEventListener('shopify:section:load', function (e) { first(e.target); });
})();
